import React from "react";
import { Button, Modal, Overlay, Tooltip, Row, Col, Form, Alert } from 'react-bootstrap';
import * as PSLib from 'poolside-js-lib';
import Locale from "../../locale/Locale";

export default class Flow extends React.Component {

    nodeWidth = 450;
    nodeHeight = 60;
    nodeColor = "#cccccc";
    width = 400;
    height = 450;
    lineHeight = 115;
    nodeMargin = 25;
    drawnItemCache = {};

    componentDidUpdate(prevProps) {
        this.width = this.props.width || this.width;
        this.height = this.props.height || this.height;
    }

    renderGraph() {
        let graph = [];
        let mainPump = this.findItem(this.props.graph.Pump);
        let midX = 0 - this.nodeWidth / 2;
        let midY = 0 - this.nodeHeight / 2;
        let mainPumpNode = this.renderNode(mainPump, midX, midY);
        this.drawnItemCache[mainPump.UUID] = mainPumpNode;
        graph.push(mainPumpNode);
        
        let highlightPath = {};
        let isHighLightedSuction = this.isLineHightlighted(this.props.graph.Pump, this.props.graph.Suction.UUID, -1);
        //console.log("Suction", this.calcMaxes(this.props.graph.Suction));
        let suctionLine = this.renderNodes(this.props.graph.Suction, midX, midY - this.lineHeight, -1, [], highlightPath);
        if (suctionLine?.length > 0) {
            graph = graph.concat(suctionLine);
            graph.push(this.renderArrow(suctionLine[0], mainPumpNode, isHighLightedSuction));
        }
        //console.log("highlightPath1", highlightPath);
        
        //console.log("Return", this.calcMaxes(this.props.graph.Return));
        let isHighLightedReturn = this.isLineHightlighted(this.props.graph.Pump, this.props.graph.Return.UUID, 1);
        //console.log("isHighLightedReturn", isHighLightedReturn);
        let returnLine = this.renderNodes(this.props.graph.Return, midX, midY + this.lineHeight, 1, [], highlightPath);
        if (returnLine?.length > 0) {
            graph = graph.concat(returnLine);
            graph.push(this.renderArrow(mainPumpNode, returnLine[0], isHighLightedReturn));
        }

        graph = graph.concat(this.renderLines(this.props.graph.Suction, -1, [], highlightPath));
        graph = graph.concat(this.renderLines(this.props.graph.Return, 1, [], highlightPath));

        return graph
    }

    renderNodes(item, x, y, dir = 1, drawPath = []) {
        if (!item)
            return;
        let components = [];
        let itemObj = this.findItem(item.UUID);
        let itemNode =  this.renderNode(itemObj, x, y);
        drawPath.push(item.UUID);
        this.drawnItemCache[dir + '_' + drawPath.join('_')] = itemNode;
        if (!this.isBody(item.UUID)) {
            this.drawnItemCache[item.UUID] = itemNode;
        }
        
        let dbgUUID = null;//"3dd9b1bc-d8e3-4c18-ba82-4SOLARHEATER";

        components.push(itemNode);

        if ((!item.ConnectedThings || item.ConnectedThings.length === 0) && itemObj.ConnectTo) {
            return components;
        }

        if (item.ConnectedThings && item.ConnectedThings.length > 0) {
            let downMaxes = this.calcMaxes(item);
            let xOffset = item.ConnectedThings.length > 1 ? 
                            (-1 * downMaxes.width) / 2 :
                            0;

            if (item.UUID === dbgUUID) {
                console.log("------------");
                console.log(dir, downMaxes, xOffset);
            }

            for (let thing of item.ConnectedThings) {
                let thingMaxes = this.calcMaxes(thing);

                if (item.ConnectedThings.length > 1)
                    xOffset += thingMaxes.width / 2;

                let thingNode = this.renderNodes(thing, x + xOffset, y + (this.lineHeight * dir), dir, drawPath);

                xOffset += thingMaxes.width / 2;

                if (item.UUID === dbgUUID)
                    console.log(x, xOffset, thing.UUID, thingMaxes);

                components.push(thingNode);
            }
            if (item.UUID === dbgUUID)
                console.log("------------");
        }

        return components;
    }

    renderLines(item, dir = 1, drawPath = [], highlightPath = {}) {
        if (!item)
            return;
        let components = [];
        let itemObj = this.findItem(item.UUID);
        drawPath.push(item.UUID);
        let itemNode = this.drawnItemCache[dir + '_' + drawPath.join('_')];

        if ((!item.ConnectedThings || item.ConnectedThings.length === 0) && itemObj.ConnectTo) {
            let tmpPath = [...drawPath];
            tmpPath.push(itemObj.ConnectTo);
            let thingNode = this.drawnItemCache[itemObj.ConnectTo];
            let isHighLighted = this.isLineHightlighted(item.UUID, itemObj.ConnectTo, dir);
            if (thingNode) {
                if (dir < 0) {
                    components.push(this.renderArrow(thingNode, itemNode, isHighLighted));
                } else {
                    components.push(this.renderArrow(itemNode, thingNode, isHighLighted));
                }
            } else {
                console.log("NotRenderedYet", itemObj.ConnectTo);
                //console.log("NotRenderedYet", dir + '_' + tmpPath.join('_'));
            }
            return components;
        }

        if (item.ConnectedThings && item.ConnectedThings.length > 0) {
            for (let child of item.ConnectedThings) {
                let tmpPath = [...drawPath];
                tmpPath.push(child.UUID);
                let childNode = this.drawnItemCache[dir + '_' + tmpPath.join('_')];
                let isHighLighted = this.isLineHightlighted(item.UUID, child.UUID, dir);
                
                try {
                    if (dir < 0) {
                        components.push(this.renderArrow(childNode, itemNode, isHighLighted));
                    } else {
                        components.push(this.renderArrow(itemNode, childNode, isHighLighted));
                    }
                } catch (e) { 
                    console.log(e);
                }

                components = components.concat(this.renderLines(child, dir, drawPath, highlightPath));
            }
        }

        return components;
    }

    findItem(uuid) {
        return this.props.siteConfig.Devices.find((item) => item.UUID === uuid) || 
                this.props.siteConfig.BodiesOfWater.find((item) => item.UUID === uuid) || 
                this.props.siteConfig.WaterFeatures.find((item) => item.UUID === uuid);
    }

    showStateTooltip(target, node) {
        let nodeState = this.getNodeStates(node);
        let stateTextArr = [ node.Name || node.DeviceType ];
        let stateFilter = [ "UUID", "Value",
            "PowerState", "ActualPowerState", "DesiredPowerState",
            "Temperature", "Calibrated", "Watts",
            "Speed", 
            "GPM", "PrimingUntil", "SupportedModes",
            "DutyCycleMinutes", "DutyCyclePowerState",
            "BatteryLevel",
            "Winterized"
        ];
        for (let key of stateFilter) {
            if (nodeState[key])
                stateTextArr.push(<div key={key} style={{ wrap: 'nowrap' }}>{ key + ": " + nodeState[key] }</div>);
        }

        this.extraElement = (
            <Overlay target={ target.current } show={ true } placement="bottom">
                <Tooltip id="node-status-overlay">
                    { stateTextArr }
                </Tooltip>
            </Overlay>
        );
        this.setState({});
    }

    renderNode(node, x, y) {
        let isOn = this.getNodeStatus(node);
        let devType = node.DeviceType ? node.DeviceType.toLowerCase() : "";
        const target = React.createRef();
        let nodeState = this.getNodeStates(node);
        let nodeName = node.Name || node.DeviceType;
        let textPos = this.nodeHeight / 2 + 10;
        let stateText = "";
        if (nodeState.ActualPowerState === "ON" && Number(nodeState.ActualSpeedPercent) > 0) {
            stateText = nodeState.ActualSpeedPercent + "%";
        } else if (nodeState.ActualPowerState === "ON" && Number(nodeState.DesiredOutputLevelPercent) > 0) {
            stateText = nodeState.DesiredOutputLevelPercent + "%";
        } else if (devType === "saltcell" && nodeState.DesiredOutputLevelPercent) {
            stateText = nodeState.DesiredOutputLevelPercent + "% / " + nodeState.SaltLevel;
        } else if (devType === "thermistor" && nodeState.Temperature) {
            stateText = Math.round(Number(nodeState.Temperature) * 10) / 10;
        } else if (nodeState.ActualPowerState === "ON" && nodeState.PressurePsi) {
            stateText = nodeState.PressurePsi;
        } else if (['phprobe', 'orpprobe'].indexOf(devType) !== -1 && nodeState.Value) {
            stateText = nodeState.Value;
        } else if (this.props.highlightPath?.PumpSpeeds && this.props.highlightPath?.PumpSpeeds[node.UUID]) {
            nodeName += ' (' + this.props.highlightPath?.PumpSpeeds[node.UUID] + '%)';
        } else if (this.props.highlightPath?.PumpSpeeds && node?.DeviceType === 'Pump') {
            nodeName += ' (' + Locale.gettext("Off") + ')';
        }
        if (stateText.length > 0) {
            textPos = this.nodeHeight / 4 + 10;
        }

        return ( 
            <g key={ node.UUID + "_" + x + "_" + y } 
                ref={ target }
                uuid={ node.UUID } 
                transform={ "translate(" + x +"," + y + ")" } 
                x={ x } y={ y } 
                width={ this.nodeWidth } height={ this.nodeHeight }
                alt={ stateText }
                onMouseOver={ (e) => {
                    if (this.props.stateTooltip)
                        this.showStateTooltip(target, node) 
                } }
                onMouseOut={ (e) => {
                    this.clearExtraElement();
                } }

                onClick={ (e) => {
                    if (this.props.stateTooltip) {
                        this.extraElement2 = (
                            <Modal
                                show={ true } 
                                scrollable={ true }
                                backdrop="static"
                                onHide={ () => { this.clearExtraElement(); } }
                                dialogClassName="wideDialog"
                            >
                                <Modal.Header closeButton >
                                    <Modal.Title>State info: { nodeName }</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{  }} >
                                    <div style={{ display: 'inline-block', width: '45%', verticalAlign: 'top' }}>
                                        { Object.keys(nodeState).map(key => <div key={key} style={{ wrap: 'nowrap' }}>{ key + ": " + nodeState[key] }</div>) }
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={ () => { this.clearExtraElement2(); }}>Close</Button>
                                </Modal.Footer>
                            </Modal>
                        );
                        this.setState({});
                    }
                }}
            >
                <rect width={this.nodeWidth} height={this.nodeHeight} className={ "flowNode " + isOn + " " + (nodeState?.Moving > 0 ? "moving" : "") +  " " + devType } rx="5" ry="5"/>
                <text textAnchor="middle" 
                    x={ this.nodeWidth / 2 } y={ textPos }
                    className="flowNodeText" 
                    style={{ }}
                >
                    { nodeName }
                </text>
                { 
                    stateText.length > 0 ? 
                        <text textAnchor="middle" x={this.nodeWidth/2} y={this.nodeHeight/4*3 + 5} className="flowNodeTextSub" style={{ }}>
                            { stateText }
                        </text>
                        : null
                }
            </g>
        );
    }

    isFlowing() {
        let mainPump = this.findItem(this.props.graph.Pump);
        return this.getNodeStatus(mainPump) === "on";
    }

    getNodeStates(node) {
        let nodeState = {
            UUID: node.UUID
        };
        for (let state of this.props.siteStatus.filter(status => status.item === node.UUID)) {
            nodeState[state.name] = state.state;
        }
        return nodeState;
    }
    
    getNodeStatus(node) {
        let isOn = "off";
        let nodeStatus = this.props.siteStatus.find(status => status.item === node.UUID && status.name === "PowerState" );
        if (nodeStatus && nodeStatus.state) {
            isOn = nodeStatus.state.toLowerCase();
        }
        return isOn;
    }

    isBody(uuid) {
        let bodiesOfWater = this.props.siteConfig.BodiesOfWater;
        return bodiesOfWater.find(bdy => bdy.UUID === uuid);
    }
    
    isLineHightlighted(uuid1, uuid2, direction = 1) {
        if (!this.props.highlightPath)
            return false;
        let pathKey = direction === 1 ? "Return" : "Suction";
        let hlData = PSLib.Config.generateHighlightPaths(
            this.props.highlightPath?.FlatFlow,
            this.props.graph.UUID,
            { data: this.props.siteConfig }
        );

        let res = false;
        for (let hld of hlData[pathKey]) {
            let u1Key = hld.indexOf(hld.find(ffi => ffi === uuid1));
            let u2Key = hld.indexOf(hld.find(ffi => ffi === uuid2));
            if (u1Key + 1 === u2Key) {
                res = true;
            }
        }

        return res;
    }

    renderArrow(from, to, flowing) {
        let start = [ 
            (from.props.x + from.props.width / 2),
            (from.props.y + from.props.height)
        ];
        let end = [ 
            (to.props.x + to.props.width / 2),
            (to.props.y)
        ];
        let tipSize = 10;
        let tipPoints = "-"+tipSize+",-"+tipSize+" "+tipSize+",-"+tipSize+" 0,0";
        if (from.props.y > to.props.y) { // if source is highter then the target
            start[1] = from.props.y;
            end[1] = to.props.y + to.props.height;
            tipPoints = "-"+tipSize+","+tipSize+" "+tipSize+","+tipSize+" 0,0";
        }
        if (from.props.y === to.props.y) {
            //console.log("Same Line");
            if (start[0] < end[0]) {
                tipPoints = "-"+tipSize+",-"+tipSize+" -"+tipSize+","+tipSize+" 0,0";
                start[0] = from.props.x + from.props.width;
                start[1] = from.props.y + from.props.height / 2;
                end[0] = to.props.x;
                end[1] = to.props.y + to.props.height / 2;
            } else if (end[0] < start[0]) {
                tipPoints = ""+tipSize+",-"+tipSize+" "+tipSize+","+tipSize+" 0,0";
                start[0] = from.props.x;
                start[1] = from.props.y + from.props.height / 2;
                end[0] = to.props.x + to.props.width;
                end[1] = to.props.y + to.props.height / 2;
            }
        }
        let mid1 = [ 
            start[0],
            start[1] + (end[1] - start[1]) / 2,
        ];
        let mid2 = [ 
            end[0],
            start[1] + (end[1] - start[1]) / 2,
        ];

        return (
            <g key={"arrow_" + from.props.uuid + "_" + to.props.uuid}>
                <line x1={start[0]} y1={start[1]} x2={mid1[0]} y2={mid1[1]} className={ "flowLine " + ( flowing ? 'flowing' : '') } />
                <line x1={mid1[0]} y1={mid1[1]} x2={mid2[0]} y2={mid2[1]} className={ "flowLine " + ( flowing ? 'flowing' : '') } />
                <line x1={mid2[0]} y1={mid2[1]} x2={end[0]} y2={end[1]} className={ "flowLine " + ( flowing ? 'flowing' : '') } />
                <g transform={"translate(" + (end[0]) + "," + (end[1]) + ")"} >
                    <polygon 
                        points={tipPoints}
                        className={ "flowLineTip " + ( flowing ? 'flowing' : '') }
                    />
                </g>
            </g>
        );
    }

    calcTotals() {
        let totals = {
            width: this.nodeWidth + this.nodeMargin,
            height: 0
        };
        if (this.props.graph.Suction) {
            let suctionMaxes = this.calcMaxes(this.props.graph.Suction);

            totals.height += suctionMaxes.height;
            totals.width = Math.max(totals.width, suctionMaxes.width);
        }
        if (this.props.graph.Return) {
            let returnMaxes = this.calcMaxes(this.props.graph.Return);

            totals.height += returnMaxes.height;
            totals.width = Math.max(totals.width, returnMaxes.width);
        }

        return totals;
    }

    calcMaxes(item, height = 0) {
        let totals = {
            width: this.nodeWidth + this.nodeMargin,
            height: (this.lineHeight) + (height === 0 ? this.nodeHeight/2 : height)
        };
        let itemObj = this.findItem(item.UUID);
        if ((!item.ConnectedThings || item.ConnectedThings.length === 0) && itemObj.ConnectTo) {
            return totals;
        }

        if (item?.ConnectedThings?.length > 0) {
            //let childWidths = [];
            let cWidthSum = 0;
            let cWidthMax = 0;
            let cHeightMax = 0;
            for (let child of item.ConnectedThings) {
                let childObj = this.findItem(child.UUID);
                if ((!child.ConnectedThings || child.ConnectedThings.length === 0) && childObj.ConnectTo) {
                    cWidthSum += this.nodeWidth/2 + this.nodeMargin;
                } else {
                    let childTotals = this.calcMaxes(child, totals.height);
                    cWidthMax = Math.max(childTotals.width, cWidthMax);
                    //childWidths.push(childTotals.width);
                    cWidthSum += childTotals.width;

                    cHeightMax = Math.max(childTotals.height, cHeightMax);
                }
            }
            //cWidthSum += cWidthMax * item.ConnectedThings.length;
            //totals.width = (this.nodeWidth + this.nodeMargin * 2) * item.ConnectedThings.length
            //totals.height += item.ConnectedThings.length * this.nodeHeight * 2;
            totals.height = cHeightMax;
            
            //totals.width = Math.max(childWidths.reduce((a, b) => a + b, 0), totals.width);
            //totals.width = Math.max(Math.max(0, ...childWidths) * item.ConnectedThings.length, totals.width);
            totals.width = Math.max(cWidthSum, totals.width);
        }

        return totals;
    }

    render() {
        let totals = this.calcTotals();
        let returnMaxes = this.calcMaxes(this.props.graph.Return);
        //console.log("returnMaxes", returnMaxes);
        let suctionMaxes = this.calcMaxes(this.props.graph.Suction);
        let scale = Math.min(Math.min(
            this.width / (totals.width + this.nodeMargin * 8),
            this.height / (totals.height + this.nodeMargin * 8)
        ), 1.5);
        let yOffset = (suctionMaxes.height - returnMaxes.height) / 2 * scale;
        //console.log("totals", totals, scale, yOffset);
        //console.log(suctionMaxes, returnMaxes);
        //console.log(suctionMaxes.height, returnMaxes.height, scale, yOffset);

        let pos = {
            x: this.width / 2,
            y: this.height / 2 + yOffset
        };
        let title = this.props.title || this.props.graph.Name;

        return (
            <div className="flowCard">
                <svg width={this.width} height={this.height} className="flow">
                    { this.props.showName === false ? null : <text  x={10} y={20} style={{ fontSize: 20 }}>{ title }</text> }
                    <g x="0" y="0" transform={"translate(" + ( pos.x ) +"," + ( pos.y ) + "), scale(" + scale + ")"} >
                        { this.renderGraph() }
                        { this.props.debug ? 
                            (<g x="0" y="0" >
                                <line x1={-100} y1={0} x2={100} y2={0} className={ "originLine" } />
                                <line x1={0} y1={-100} x2={0} y2={100} className={ "originLine" } />
                            </g>) : null
                        }
                        { this.props.debug ? 
                            (<g x="0" y="0" >
                                <line x1={0-returnMaxes.width / 2} y1={0} x2={returnMaxes.width / 2} y2={0} className={ "originLineRed" } />
                                <line x1={0-returnMaxes.width / 2} y1={0} x2={0-returnMaxes.width / 2} y2={returnMaxes.height} className={ "originLineRed" } />
                            </g>) : null
                        }
                        { this.props.debug ? 
                            (<g x="0" y="0" >
                                <line x1={0-suctionMaxes.width / 2} y1={0} x2={suctionMaxes.width / 2} y2={0} className={ "originLineBlue" } />
                                <line x1={suctionMaxes.width / 2} y1={0} x2={suctionMaxes.width / 2} y2={0-suctionMaxes.height} className={ "originLineBlue" } />
                            </g>) : null
                        }
                    </g>
                </svg>
                { this.extraElement }
                { this.extraElement2 }
            </div> 
        )
        /*
        <line x1="0" y1="0" x2="0" y2="150" className="flowOrigin"/>
        <line x1="0" y1="0" x2="150" y2="0" className="flowOrigin"/>
        */
    }

    clearExtraElement() {
        this.extraElement = null;
        this.setState({});
    }

    clearExtraElement2() {
        this.extraElement2 = null;
        this.setState({});
    }
}